var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91667 15.625H9.08333C9.08333 16.4959 8.37083 17.2084 7.5 17.2084C6.62917 17.2084 5.91667 16.4959 5.91667 15.625ZM14.625 14.0417V14.8334H0.375V14.0417L1.95833 12.4584V7.70836C1.95833 5.25419 3.54167 3.11669 5.91667 2.40419V2.16669C5.91667 1.29586 6.62917 0.583358 7.5 0.583358C8.37083 0.583358 9.08333 1.29586 9.08333 2.16669V2.40419C11.4583 3.11669 13.0417 5.25419 13.0417 7.70836V12.4584L14.625 14.0417ZM11.4583 7.70836C11.4583 5.49169 9.71667 3.75002 7.5 3.75002C5.28333 3.75002 3.54167 5.49169 3.54167 7.70836V13.25H11.4583V7.70836Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3b9bdd34.svg";
export { ForwardRef as ReactComponent };